import KeyValuePair from '@/modules/core/support/KeyValuePair'
import _ from 'lodash'

/**
 * Almacena la configuración de la aplicación
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export class Config {

    /**
     * Constructor
     *
     * @param config
     */
    constructor (private config: KeyValuePair = {}) {}

    /**
     * Permite obtener un parámetro de configuración
     *
     * @param key
     * @param _default
     */
    public get (key: string, _default: any) {
        return _.get(this.config, key, _default)
    }

    /**
     * Establece un parámetro de configuración
     *
     * @param key
     * @param value
     */
    public set (key: string, value: any) {
        _.set(this.config, key, value)

        return this
    }

    /**
     * Crea una entidad de configuración en base a la información plana obtenida
     *
     * @param data
     */
    public static deserialize (data: KeyValuePair) {
        return new this(data)
    }
}
